import P, { InferProps } from 'prop-types';
import React from 'react';
import CardMedia from '@mui/material/CardMedia';
import { SxStyle } from '../../../../types';
import APP_INFO from '../assets/MODULE_APP_INFO.png';
import LEADER_TABLE_CARD from '../assets/MODULE_LEADER_TABLE_CARD.png';
import LINKS from '../assets/MODULE_LINKS.png';
import MATCH_CARD from '../assets/MODULE_MATCH_CARD.png';
import MATCH_LIST_CARD from '../assets/MODULE_MATCH_LIST_CARD.png';
import NOTIFICATION_CARD from '../assets/MODULE_NOTIFICATION_CARD.png';
import SIDE_SCROLLING_NEWS from '../assets/MODULE_SIDE_SCROLLING_NEWS.png';
import SIDE_SCROLLING_TEAMS from '../assets/MODULE_SIDE_SCROLLING_TEAMS.png';
import STANDINGS_TABLE from '../assets/MODULE_STANDINGS_TABLE.png';
import TEAM_PLAYERS_BANNER from '../assets/MODULE_TEAM_PLAYERS_BANNER.png';
import TEAM_PLAYERS from '../assets/MODULE_TEAM_PLAYERS.png';
import UNIBET_PROMO_WEBVIEW from '../assets/MODULE_UNIBET_PROMO_WEBVIEW.png';
import NO_PREVIEW_AVAILABLE from '../assets/NO_PREVIEW_AVAILABLE.png';
import { MODULE_TYPES, PreviewModuleTypes } from '../types';
import { Card, Chip, Stack } from '@mui/material';
import { Promo } from '../../../../types/app-config';

const MODULE_IMAGES: Partial<PreviewModuleTypes> = {
  NO_PREVIEW_AVAILABLE: NO_PREVIEW_AVAILABLE,
  SIDE_SCROLLING_TEAMS: SIDE_SCROLLING_TEAMS,
  UNIBET_PROMO_WEBVIEW: UNIBET_PROMO_WEBVIEW,
  SIDE_SCROLLING_NEWS: SIDE_SCROLLING_NEWS,
  TEAM_PLAYERS_BANNER: TEAM_PLAYERS_BANNER,
  LEADER_TABLE_CARD: LEADER_TABLE_CARD,
  NOTIFICATION_CARD: NOTIFICATION_CARD,
  STANDINGS_TABLE: STANDINGS_TABLE,
  MATCH_LIST_CARD: MATCH_LIST_CARD,
  TEAM_PLAYERS: TEAM_PLAYERS,
  MATCH_CARD: MATCH_CARD,
  APP_INFO: APP_INFO,
  LINKS: LINKS,
};

const styles: SxStyle = {
  media: {
    objectFit: 'contain',
  },
  card: {
    position: 'relative',
    margin: '10px',
    borderRadius: '8px',
    backgroundColor: 'none',
  },
  chipOverlay: {
    position: 'absolute',
    top: '6px',
    right: '6px',
    border: '1px solid black',
  },
};

function CardBackgroundImg({
  sceneModule,
  promos,
}: InferProps<typeof CardBackgroundImg.propTypes>) {
  const imageSources = [];
  let imageLabel = sceneModule.name;

  if (sceneModule.type === MODULE_TYPES.PROMO) {
    const promoIndexField = sceneModule.fields.find((field) => field.key === 'promoIndex');
    if (promoIndexField && typeof promoIndexField.value === 'string' && promos) {
      const promoIndex: keyof Promo[] = parseInt(promoIndexField.value);
      const promoImageURL = promos[promoIndex]?.contentUrl ?? '';
      imageSources.push(promoImageURL ? promoImageURL : NO_PREVIEW_AVAILABLE);
      imageLabel = `Promo ${promoIndex}`;
    }
  } else if (sceneModule.type === MODULE_TYPES.PROMO_IMAGES) {
    const promoIndexesField = sceneModule.fields.find((field) => field.key === 'promoIndexes');
    if (promoIndexesField && Array.isArray(promoIndexesField.value) && promos) {
      promoIndexesField.value.forEach((promoIndex) => {
        const promoImageURL = promos[parseInt(promoIndex, 10)]?.contentUrl ?? '';
        imageSources.push(promoImageURL ? promoImageURL : NO_PREVIEW_AVAILABLE);
      });
      imageLabel = `Promo ${promoIndexesField.value.join(', ')}`;
    }
  } else {
    const moduleType = sceneModule.type.replaceAll('MODULE_', '') as keyof PreviewModuleTypes;
    const isImageAvailable = !!(moduleType in MODULE_IMAGES && MODULE_IMAGES[moduleType]);
    imageSources.push(isImageAvailable ? MODULE_IMAGES[moduleType] : NO_PREVIEW_AVAILABLE);
  }

  return (
    <Card sx={styles.card} elevation={2}>
      <Chip label={imageLabel} size="small" color="primary" sx={styles.chipOverlay} />
      <Stack direction="row">
        {imageSources?.length > 0 &&
          imageSources.map((imageSource, index) => (
            <CardMedia
              key={imageSource + index}
              image={imageSource}
              alt={sceneModule.name}
              component="img"
              style={{ width: `calc(100% / ${imageSources.length})` }}
              sx={styles.media}
            />
          ))}
      </Stack>
    </Card>
  );
}

CardBackgroundImg.propTypes = {
  sceneModule: P.shape({
    name: P.string.isRequired,
    type: P.string.isRequired,
    fields: P.arrayOf(
      P.shape({
        title: P.string.isRequired,
        id: P.string.isRequired,
        type: P.string,
        validation: P.any,
        key: P.string,
        value: P.any,
      }).isRequired
    ).isRequired,
  }).isRequired,
  promos: P.arrayOf(P.any).isRequired,
};

export default CardBackgroundImg;
